import { getLogger } from '@ravago/shared/logging/client';
import { DocumentVersionType, Invoice, InvoiceQueryParams, PaginatedResponse } from '@ravago/shared/page-data/models/elements';

export interface DownloadInvoiceDocumentParams {
  invoiceId: string | number;
  documentId: number;
  documentVersionType: DocumentVersionType;
  correlationId: string;
}

export class InvoiceClientUtils {
  static async getClosedInvoices(query?: InvoiceQueryParams): Promise<PaginatedResponse<Invoice[]> | undefined> {
    const searchParams = new URLSearchParams();
    if (query) {
      Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          searchParams.append(key, value.toString());
        }
      });
    }

    try {
      const response = await fetch(`/api/invoices/closed?${searchParams.toString()}`);

      if (!response.ok) {
        return undefined;
      }

      return await response.json();
    } catch (error) {
      getLogger().error(error instanceof Error ? error.message : 'Unknown error occurred');

      return undefined;
    }
  }

  /**
   * Downloads an invoice document via the `/api/customer/invoices/.../download` API route.
   * Returns the binary as a Blob, ready to hand to `file-saver`.
   */
  static async downloadInvoiceDocument({ invoiceId, documentId, documentVersionType, correlationId }: DownloadInvoiceDocumentParams): Promise<Blob> {
    const response = await fetch(`/api/customer/invoices/${invoiceId}/documents/${documentId}/download?documentVersionType=${documentVersionType}`, {
      headers: { 'x-ravago-correlation-id': correlationId }
    });

    if (!response.ok) throw new Error(`Invoice document download failed with status ${response.status}`);
    return response.blob();
  }
}

